import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';

export const advisorSupport = [
	{
		path: '/advisor-support',
		Component: withFeatureFlag(
			withProtected(lazy(() => import('../pages/AdvisorSupport'))),
			'advisor-support-enabled',
			{
				defaultOn: true
			}
		),
		children: [
			{
				path: '/advisor-support/',
				Component: lazy(() => import('../pages/AdvisorSupport/AdvisorSupport')),
				handle: {
					key: 'pages.advisorSupport.title'
				}
			},
			{
				path: '/advisor-support/book/:meetingTypeSlug',
				Component: lazy(() => import('../pages/AdvisorSupport/BookSession')),
				handle: {
					key: 'pages.advisorSupport.bookSession'
				}
			},
			{
				path: '/advisor-support/bookings/:bookingId',
				Component: lazy(() => import('../pages/AdvisorSupport/BookingDetails')),
				handle: {
					key: 'pages.advisorSupport.bookingDetails'
				}
			}
		]
	}
];
